<template>
	<portlet class="form-query" hide-title="true">
		 <el-table
                :data="list"
                style="margin-top: 10px"
                highlight-current-row
                @row-click="handleRowItem"
                border
                stripe>
                <el-table-column
                    :show-overflow-tooltip="true"
                    property="materialCode"
                    label="款号"
                    :min-width="150"
                    ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    property="materialDescCn"
                    label="款名"
                    :min-width="150"
                    ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    property="updatedTime"
                    label="更新日期"
                    :min-width="120"
                    >
                        <template slot-scope="scope">
                            {{$utils.formatTime(scope.row.updatedTime)}}
                        </template>
                    </el-table-column>
            </el-table>
		<el-row>
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="pageConfig.pageNo"
                :page-size="pageConfig.pageSize"
                layout="prev, pager, next, jumper"
                :total="pageConfig.total">
                </el-pagination>
        </el-row>
	</portlet>
</template>
<script>


export default {
	name: 'special-table',
    props: {
		list: {
			type: Array,
			default: () => ([])
		},
		pageConfig: {
			type: Object,
			default: () => ({
				pageSize: 10,
                pageNo: null,
                total: 0
			})
		}
	},
	methods: {
		handleCurrentChange(val) {
			this.$emit('handleCurrentChange', val)
		},
		handleRowItem(row) {
            // this.$store.dispatch('saveDescriptionPKID', row.id)
			this.$emit('handleRowItem', row);
		}
	},
    data() {
        return {
        }
    }
}
</script>

<style scoped>
</style>
